export default {
    auth: {
        sendCode: "/api/auth/send-code",
        validateCode: "/api/auth/validate-code",
        passwordLogin: "/api/auth/password-login",
    },
    users: {
        create: "/api/users",
        memberships: {
            create: (userUid) => `/api/users/${userUid}/memberships`,
            list: (userUid, page, perPage = 10) => {
                let searchParams = new URLSearchParams({
                    page,
                    per_page: perPage,
                });

                return `/api/users/${userUid}/memberships?` + searchParams.toString();
            },
        },
        phone_number: {
            sendCode: (userUid) => `/api/users/${userUid}/phone-number/send-code`,
            checkCode: (userUid) => `/api/users/${userUid}/phone-number/check-code`,
        },
        get: (uid) => `/api/users/${uid}`,
    },
    relatives: {
        create: (slug, memberUID) => `/${slug}/members/${memberUID}/relatives`,
        delete: (slug, memberUID, beneficiaryID) => `/${slug}/members/${memberUID}/relatives/${beneficiaryID}`,
        update: (slug, memberUID, beneficiaryID) => `/${slug}/members/${memberUID}/relatives/${beneficiaryID}`,
        export: (slug, memberUID) => `/${slug}/members/${memberUID}/relatives/export`,
        list: (
            slug,
            memberUID = null,
            page = 1,
            perPage = 15,
            orderBy = "name",
            orderByDirection = "asc",
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
                orderBy: orderBy,
                orderByDirection: orderByDirection,
            });

            return `/${slug}/members/${memberUID}/relatives?` + searchParams.toString();
        },
    },
    dependents: {
        create: (slug, memberUID) => `/${slug}/members/${memberUID}/dependents`,
        delete: (slug, memberUID, dependentID) => `/${slug}/members/${memberUID}/dependents/${dependentID}`,
        update: (slug, memberUID, dependentID) => `/${slug}/members/${memberUID}/dependents/${dependentID}`,
        export: (slug, memberUID) => `/${slug}/members/${memberUID}/dependents/export`,
        list: (
            slug,
            memberUID = null,
            page = 1,
            perPage = 15,
            orderBy = "name",
            orderByDirection = "asc",
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
                orderBy: orderBy,
                orderByDirection: orderByDirection,
            });

            return `/${slug}/members/${memberUID}/dependents?` + searchParams.toString();
        },
        documents: {
            list: (slug, memberUID, dependentUID) => `/${slug}/members/${memberUID}/dependents/${dependentUID}/documents`,
            attach: (slug, memberUID, dependentUID) => `/${slug}/members/${memberUID}/dependents/${dependentUID}/documents`,
            update: (slug, memberUID, dependentUID, fileUID) => `/${slug}/members/${memberUID}/dependents/${dependentUID}/documents/${fileUID}`,
            replace: (slug, memberUID, dependentUID, fileUID) => `/${slug}/members/${memberUID}/dependents/${dependentUID}/documents/${fileUID}/replace`,
            delete: (slug, memberUID, dependentUID, fileUID) => `/${slug}/members/${memberUID}/dependents/${dependentUID}/documents/${fileUID}`,
            history: (slug, memberUID, dependentUID, fileUID) => `/${slug}/members/${memberUID}/dependents/${dependentUID}/documents/${fileUID}/history`,
        },
    },
    enrollments: {
        create: (slug, memberUID) => `/${slug}/members/${memberUID}/enrollments`,
        delete: (slug, memberUID, enrollmentID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentID}`,
        update: (slug, memberUID, enrollmentID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentID}`,
        list: (
            slug,
            memberUID = null,
            page = 1,
            perPage = 15,
            orderBy = "name",
            orderByDirection = "asc",
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
                orderBy: orderBy,
                orderByDirection: orderByDirection,
            });

            return `/${slug}/members/${memberUID}/enrollments?` + searchParams.toString();
        },
        dashboardList: (slug, page = 1, perPage = 15, search = '', filters = {}) => {
            const params = new URLSearchParams({ page, per_page: perPage });
            if (search) params.append('search', search);
            ['lifecycle', 'date_from', 'date_to', 'orderBy', 'orderByDirection']
                .forEach((key) => { if (filters[key]) params.append(key, filters[key]); });
            ['policy_uids', 'policy_type_uids']
                .forEach((key) => { (filters[key] || []).forEach((value) => params.append(`${key}[]`, value)); });
            return `/${slug}/enrollments?` + params.toString();
        },
    },
    memberBeneficiaries: {
        list: (slug, memberUID, page = 1, perPage = 100) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            return `/${slug}/members/${memberUID}/beneficiaries?` + searchParams.toString();
        },
        create: (slug, memberUID) => `/${slug}/members/${memberUID}/beneficiaries`,
        update: (slug, memberUID, beneficiaryUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}`,
        delete: (slug, memberUID, beneficiaryUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}`,
        documents: {
            list: (slug, memberUID, beneficiaryUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}/documents`,
            attach: (slug, memberUID, beneficiaryUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}/documents`,
            update: (slug, memberUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}`,
            replace: (slug, memberUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}/replace`,
            delete: (slug, memberUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}`,
            history: (slug, memberUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}/history`,
        },
    },
    enrollmentBeneficiaries: {
        create: (slug, memberUID, enrollmentUID) =>
            `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries`,
        delete: (slug, memberUID, enrollmentUID, beneficiaryUID) =>
            `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}`,
        update: (slug, memberUID, enrollmentUID, beneficiaryUID) =>
            `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}`,
        list: (slug, memberUID, enrollmentUID, page = 1, perPage = 15) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            return `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries?` + searchParams.toString();
        },
        documents: {
            list: (slug, memberUID, enrollmentUID, beneficiaryUID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}/documents`,
            attach: (slug, memberUID, enrollmentUID, beneficiaryUID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}/documents`,
            update: (slug, memberUID, enrollmentUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}`,
            replace: (slug, memberUID, enrollmentUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}/replace`,
            delete: (slug, memberUID, enrollmentUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}`,
            history: (slug, memberUID, enrollmentUID, beneficiaryUID, fileUID) => `/${slug}/members/${memberUID}/enrollments/${enrollmentUID}/beneficiaries/${beneficiaryUID}/documents/${fileUID}/history`,
        },
    },
    members: {
        pedigreeSheet: (slug, memberUID) => `/${slug}/members/${memberUID}/pedigree-sheet`,
        create: "/api/members",
        bulk: {
            resendInvitation: (slug) => `/${slug}/members/bulk/resend-invitations`,
            deactivate: (slug) => `/${slug}/members/bulk/deactivate-profiles`,
            activate: (slug) => `/${slug}/members/bulk/reactivate-profiles`,
            convertToNonactive: (slug) => `/${slug}/members/bulk/convert-to-nonactive`,
            update: (slug) => `/${slug}/members/bulk/update-profiles`,
            delete: (slug) =>`/${slug}/members/bulk/wipe`,
            'add-to-groups': (slug) => `/${slug}/members/bulk/add-to-groups`,
            'remove-from-groups': (slug) => `/${slug}/members/bulk/remove-from-groups`,
            convertToInvited: (slug) => `/${slug}/members/bulk/activate-profiles`,
            generateInvoice: (slug) => `/${slug}/finvo`,
        },
        list: (
            slug,
            page = 1,
            perPage = 10,
            search = "",
            groups = [],
            accountStatuses = [],
            orderBy = "name",
            orderByDirection = "asc",
            fields = [],
            filtersOperator = "and",
            includeFields = false,
            leadershipOnly = false,
            excludeUids = [],
            uids = [],
            excludeGroups = [],
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
                orderBy: orderBy,
                orderByDirection: orderByDirection,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            groups.forEach((group) => {
                searchParams.append("groups[]", group);
            });

            accountStatuses.forEach((status) => {
                if(status !== 'deactivated') {
                    searchParams.append("statuses[]", status);
                } else {
                    searchParams.append("deactivated", 1);
                }
            });

            if(fields.length > 0) {
                // Send each filter as individual object in fields array
                fields.forEach((field, index) => {
                    searchParams.append(`fields[${index}][uid]`, field.uid);

                    // Handle array values for multiselect (serialize as JSON)
                    if (Array.isArray(field.value)) {
                        searchParams.append(`fields[${index}][value]`, JSON.stringify(field.value));
                    } else {
                        searchParams.append(`fields[${index}][value]`, field.value);
                    }

                    searchParams.append(`fields[${index}][condition]`, field.condition);
                    if (field.input_type) {
                        searchParams.append(`fields[${index}][input_type]`, field.input_type);
                    }
                });
            }

            if ((fields.length > 0 || groups.length > 0) && filtersOperator) {
                searchParams.append("operator", filtersOperator);
            }

            if(includeFields) {
                searchParams.append("includeFields", 1);
            }

            if(leadershipOnly) {
                searchParams.append("leader", 1);
            }

            if(excludeUids && excludeUids.length > 0) {
                excludeUids.forEach((uid) => {
                    searchParams.append("excludeUids[]", uid);
                });
            }

            if(uids && uids.length > 0) {
                uids.forEach((uid) => {
                    searchParams.append("uids[]", uid);
                });
            }

            if(excludeGroups && excludeGroups.length > 0) {
                excludeGroups.forEach((groupName) => {
                    searchParams.append("excludeGroups[]", groupName);
                });
            }

            return `/${slug}/members?` + searchParams.toString();
        },
        download: (
            slug,
            search = "",
            groups = [],
            accountStatuses = "",
            orderBy = "name",
            orderByDirection = "asc",
            fields = [],
            filtersOperator = "and",
            includeBeneficiaries = false,
            selectedMembers = { include: [], exclude: [] },
        ) => {
            let searchParams = new URLSearchParams({
                orderBy: orderBy,
                direction: orderByDirection,
            });

            if (includeBeneficiaries) {
                searchParams.append("include_beneficiaries", 1);
            }

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            groups.forEach((group) => {
                searchParams.append("groups[]", group);
            });

            accountStatuses.forEach((status) => {
                if(status !== 'deactivated') {
                    searchParams.append("statuses[]", status);
                } else {
                    searchParams.append("deactivated", 1);
                }
            });

            if(fields.length > 0) {
                // Send each filter as individual object in fields array
                fields.forEach((field, index) => {
                    searchParams.append(`fields[${index}][uid]`, field.uid);

                    // Handle array values for multiselect (serialize as JSON)
                    if (Array.isArray(field.value)) {
                        searchParams.append(`fields[${index}][value]`, JSON.stringify(field.value));
                    } else {
                        searchParams.append(`fields[${index}][value]`, field.value);
                    }

                    searchParams.append(`fields[${index}][condition]`, field.condition);
                    if (field.input_type) {
                        searchParams.append(`fields[${index}][input_type]`, field.input_type);
                    }
                });
            }

            // Send operator when there are multiple filters (fields or groups)
            if ((fields.length > 0 || groups.length > 0) && filtersOperator) {
                searchParams.append("operator", filtersOperator);
            }

            (selectedMembers.include ?? []).forEach((uid) => {
                searchParams.append("members[include][]", uid);
            });

            (selectedMembers.exclude ?? []).forEach((uid) => {
                searchParams.append("members[exclude][]", uid);
            });

            return `/${slug}/export-members?` + searchParams.toString();
        },
        createLeader: (slug, memberUid) => `/${slug}/members/${memberUid}/leader`,
        createMember: (slug) => `/${slug}/members`,
        manage: {
            update: (slug, memberUid) => `/${slug}/members/${memberUid}`,
            approve: (slug, memberUid) => `/${slug}/members/${memberUid}/approve`,
            deny: (slug, memberUid) => `/${slug}/members/${memberUid}/deny`,
            merge: (slug, memberUid) => `/${slug}/members/${memberUid}/merge`,
            activate: (slug) => `/${slug}/members/restore`,
            deactivate: (slug, memberUid) => `/${slug}/members/${memberUid}`,
            resendInvitation: (slug, memberUid) =>
                `/${slug}/members/${memberUid}/resend-invitation`,
            getInvitation: (slug, memberUid) =>
                `/${slug}/members/${memberUid}/invitation-url`,
            convertToInvited: (slug, memberUid) => `/${slug}/members/${memberUid}/activate-member`,
            convertToNonactive: (slug, memberUid) => `/${slug}/members/${memberUid}/convert-member-to-nonactive`,
            militaryLeave: (slug, memberUid) => `/${slug}/members/${memberUid}/military-leave`,
        },
        emails: {
            get: (slug, memberUid, isPrimary) =>
                `/${slug}/members/${memberUid}/emails?is_primary=${isPrimary}`,
            create: (slug, memberUid) => `/${slug}/members/${memberUid}/emails`,
            checkCode: (slug, memberUid) =>
                `/${slug}/members/${memberUid}/emails/check-code`,
            sendCode: (slug, memberUid) =>
                `/${slug}/members/${memberUid}/emails/send-code`,
            delete: (slug, memberUid, email) =>
                `/${slug}/members/${memberUid}/emails/${email}`,
        },
        phoneNumbers: {
            get: (slug, memberUid, isPrimary) =>
                `/${slug}/members/${memberUid}/phone-numbers?is_primary=${isPrimary}`,
            create: (slug, memberUid) =>
                `/${slug}/members/${memberUid}/phone-numbers`,
            checkCode: (slug, memberUid) =>
                `/${slug}/members/${memberUid}/phone-numbers/check-code`,
            sendCode: (slug, memberUid) =>
                `/${slug}/members/${memberUid}/phone-numbers/send-code`,
            delete: (slug, memberUid, phoneNumber) =>
                `/${slug}/api/members/${memberUid}/phone-numbers/${phoneNumber}`,
        },
        fields: {
            get: (slug, memberUid, search = '', page = null, perPage = null) => {
                let searchParams = new URLSearchParams();

                if (search && search.length > 0) {
                    searchParams.append("search", search);
                }

                if (page) {
                    searchParams.append("page", page);
                }

                if (perPage) {
                    searchParams.append("per_page", perPage);
                }

                return `/${slug}/members/${memberUid}/pb-fields?` + searchParams.toString();
            },
            update: (slug, memberUid) => `/${slug}/members/${memberUid}/pb-fields`,
            getFieldValues: (slug, page, perPage, searchQuery, fieldUid) => {
                let searchParams = new URLSearchParams();

                searchParams.append("page", page);

                if (searchQuery && searchQuery.length > 0) {
                    searchParams.append("query", searchQuery);
                }

                return `/${slug}/pb-fields/${fieldUid}/values?` + searchParams.toString();
            },
            getHistory: (slug, memberUid, fieldUid) => `/${slug}/members/${memberUid}/pb-fields/${fieldUid}/history`,
            fileHistory: (slug, memberUid, fieldUid, fileUid) => `/${slug}/members/${memberUid}/pb-fields/${fieldUid}/files/${fileUid}/history`
        },
        roles: {
            add: (slug, memberUid) => `/${slug}/members/${memberUid}/roles`,
        },
        notifications: {
            get: (
                slug,
                memberUid,
                page = 1,
                perPage = 10,
                search = "",
                types = []
            ) => {
                let searchParams = new URLSearchParams({
                    page,
                    per_page: perPage,
                });

                types.forEach((type) => {
                    searchParams.append("type[]", type);
                });

                if (search.length > 0) {
                    searchParams.append("search", search);
                }

                return (
                    `/${slug}/members/${memberUid}/notifications?` +
					searchParams.toString()
                );
            },
            read: (slug, memberUid, notificationUid) =>
                `/${slug}/members/${memberUid}/notifications/${notificationUid}/read`,
            delete: (slug, memberUid, notificationUid) =>
                `/${slug}/members/${memberUid}/notifications/${notificationUid}`,
            types: (slug) => `/${slug}/notifications/types`,
        },
        pushNotifications: {
            store: (slug, memberUid) => `/${slug}/members/${memberUid}/web-tokens`,
            delete: (slug, memberUid, tokenUid) =>
                `/${slug}/members/${memberUid}/web-tokens/${tokenUid}`,
            notifyMembers: (slug) => `/${slug}/notify-members`,
        },
        avatar: {
            store: (slug, memberUid) => `/${slug}/members/${memberUid}/avatar`,
            delete: (slug, memberUid) => `/${slug}/members/${memberUid}/avatar`,
        },
        get: (slug, memberUid, withRelation = null) => {
            if(withRelation) {
                return `/${slug}/members/${memberUid}?with[]=${withRelation}`
            }

            return `/${slug}/members/${memberUid}`
        },
        update: (slug, memberUid) => `/${slug}/members/${memberUid}`,
        showByUser: (slug, userUid = null) => `/${slug}/users/${userUid}/member`,
        getAvailableStatuses: (slug) => `/${slug}/members/statuses`,
        getProfileStatus: (slug, memberUid) =>
            `/${slug}/members/${memberUid}/profile-status`,
        getOnboardingStatus: (slug, memberUid) =>
            `/${slug}/members/${memberUid}/onboarding-status`,
        getFieldsStatus: (slug, memberUid) =>
            `/${slug}/members/${memberUid}/fields-status`,
        finishOnboarding: (slug, memberUid) =>
            `/${slug}/members/${memberUid}/finish-onboarding`,
        features: (slug) => `/${slug}/members/features`,
        widgets: {
            updateOrder: (slug, memberUid) => `/${slug}/members/${memberUid}/dashboard-widgets`,
        },
        authentication: {
            sendCode: (slug, memberUid) => `/${slug}/members/${memberUid}/authentication-phone-number`,
            checkCode: (slug, memberUid) => `/${slug}/members/${memberUid}/authentication-phone-number/check-code`,
        },
        getAuthenticationNumber: (slug, memberUid) => `/${slug}/members/${memberUid}/authentication-phone-number`,
        history: (slug, memberUid, property, uid = null) => {
            let searchParams = new URLSearchParams({
                property
            });

            if (uid) {
                searchParams.append("uid", uid);
            }

            return `/${slug}/members/${memberUid}/history?` + searchParams.toString();
        },
        // members in a group
        getMembersInGroup: (slug, groupsName = [], statuses = [], page = 1, perPage = 500) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if(!Array.isArray(groupsName)) {
                groupsName = [groupsName];
            }

            groupsName.forEach((group) => {
                searchParams.append("groups[]", group);
            });

            if(!Array.isArray(statuses)) {
                statuses = [statuses];
            }

            statuses.forEach((status) => {
                searchParams.append("statuses[]", status);
            });

            return `/${slug}/members?` + searchParams.toString();
        },
        // a member's groups
        getMemberGroups: (slug, memberUid) => `/${slug}/members/${memberUid}/groups`,
        alerts: {
            list:   (slug, memberUid)           => `/${slug}/members/${memberUid}/alerts`,
            store:  (slug, memberUid)           => `/${slug}/members/${memberUid}/alerts`,
            update: (slug, memberUid, alertUid) => `/${slug}/members/${memberUid}/alerts/${alertUid}`,
            delete: (slug, memberUid, alertUid) => `/${slug}/members/${memberUid}/alerts/${alertUid}`,
        },
    },
    pbFieldNotes: {
        list:     (slug, memberUID, pbFieldUID) => `/${slug}/members/${memberUID}/pb-fields/${pbFieldUID}/notes`,
        save:     (slug, memberUID, pbFieldUID, fileUID) => `/${slug}/members/${memberUID}/pb-fields/${pbFieldUID}/files/${fileUID}/note`,
        reassign: (slug, memberUID, pbFieldUID, fileUID) => `/${slug}/members/${memberUID}/pb-fields/${pbFieldUID}/files/${fileUID}/note/reassign`,
        replace:  (slug, memberUID, pbFieldUID, fileUID) => `/${slug}/members/${memberUID}/pb-fields/${pbFieldUID}/files/${fileUID}/replace`,
    },
    leaders: {
        update: (slug, leaderUid) => `/${slug}/leader/${leaderUid}`,
        delete: (slug, leaderUid) => `/${slug}/leader/${leaderUid}`,
    },
    importMembers: {
        list: (slug, page = 1, isNonActive = 0) => `/${slug}/import-members?page=${page}&non-active=${isNonActive}`,
        batchStore: (slug) => `/${slug}/import-members/batch`,
        batchUpdate: (slug) => `/${slug}/import-members/batch`,
        batchDelete: (slug) => `/${slug}/import-members/batch`,
        start: (slug) => `/${slug}/import-members/start`,
        bulkUpdateColumn: (slug) => `/${slug}/import-members/bulk-update`,
        exportErrors: (slug) => `/${slug}/import-members/errors/export`,
    },
    reconciliations: {
        list: (slug) => `/${slug}/reconciliations`,
        create: (slug) => `/${slug}/reconciliations`,
        show: (slug, uid) => `/${slug}/reconciliations/${uid}`,
        update: (slug, uid) => `/${slug}/reconciliations/${uid}`,
        run:      (slug, uid) => `/${slug}/reconciliations/${uid}/run`,
        cancel: (slug, uid) => `/${slug}/reconciliations/${uid}`,
        download: (slug, uid) => `/${slug}/reconciliations/${uid}/download`,
        records: (slug, uid) => `/${slug}/reconciliations/${uid}/records`,
        recordsSummary: (slug, uid) => `/${slug}/reconciliations/${uid}/records/summary`,
        recordsSegments: (slug, uid) => `/${slug}/reconciliations/${uid}/records/segments`,
        setVerdict: (slug, uid) => `/${slug}/reconciliations/${uid}/records`,
        undoVerdict: (slug, uid) => `/${slug}/reconciliations/${uid}/records/undo`,
        setEffectiveDates: (slug, uid) => `/${slug}/reconciliations/${uid}/records/effective-dates`,
        apply:    (slug, uid) => `/${slug}/reconciliations/${uid}/apply`,
        recheckGroups: (slug, uid) => `/${slug}/reconciliations/${uid}/recheck-groups`,
        rollback: (slug, uid) => `/${slug}/reconciliations/${uid}/rollback`,
    },
    organizations: {
        search: (name, page = 1, perPage = 15) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (name && name.length > 0) {
                searchParams.append("name", name);
            }

            return `/api/organizations/?` + searchParams.toString();
        },
        get: (slug) => `/api/organizations/${slug}`,
        uploadLogo: (slug) => `/${slug}/logo`,
        uploadCover: (slug) => `/${slug}/cover`,
        deleteLogo: (slug) => `/${slug}/logo/delete`,
        deleteCover: (slug) => `/${slug}/cover/delete`,
        updateInfo: (slug) => `/${slug}/info`,
        update: (slug) => `/api/organizations/${slug}`,
        getNewsConfig: (slug) => `/api/organizations/${slug}/config/news`,
        getResourcesConfig: (slug) => `/api/organizations/${slug}/config/resources`,
        updateMembersListSettings: (slug) => `/api/organizations/${slug}/members-list-settings`,
        getMembersListSettings: (slug) => `/api/organizations/${slug}/members-list-settings`,
        getMembersBeneficiaryPermission: (slug) => `/api/organizations/${slug}/beneficiaries_settings`,
        updateMembersBeneficiaryPermission: (slug) => `/api/organizations/${slug}/beneficiaries_settings`
    },
    organization: {
        getRoles: (slug) => `/${slug}/roles`,
    },
    invitation: {
        send: (slug) => `/${slug}/members`,
    },
    invitations: {
        get: (uid, token) => `/api/invitations/${uid}?token=${token}`,
        update: (uid, token) => `/api/invitations/${uid}?token=${token}`,
        phone_number: {
            sendCode: (uid, token) =>
                `/api/invitations/${uid}/phone-number/send-code?token=${token}`,
            checkCode: (uid, token) =>
                `/api/invitations/${uid}/phone-number/check-code?token=${token}`,
        },
    },
    profileBuilder: {
        tabs: {
            get: (slug, uid = null, searchFieldName) => {
                let searchParams = new URLSearchParams();
                if (uid) {
                    searchParams.append("pb_tab_uid", uid);
                }

                if(searchFieldName && searchFieldName.length > 0) {
                    searchParams.append("field_search", searchFieldName);
                }

                return `/${slug}/pb-tabs?` + searchParams.toString();
            },
            add: (slug) =>  `/${slug}/pb-tabs`,
            reorder: (slug) => `/${slug}/pb-tabs/reorder`,
            delete: (slug, uid) => `/${slug}/pb-tabs/${uid}`,
            update: (slug, uid) => `/${slug}/pb-tabs/${uid}`,
        },
        fields: {
            getOrganizationFields: (slug, excludeFiles = false, page = 1, perPage = 10, search = "", universal = null, uids = []) => {
                let searchParams = new URLSearchParams({
                    page,
                    per_page: perPage,
                });

                if (search && search.length > 0) {
                    searchParams.append("name", search);
                }

                if(universal !== null) {
                    searchParams.append("universal", universal);
                }

                if(uids && uids.length > 0) {
                    uids.forEach((uid) => {
                        searchParams.append("uids[]", uid);
                    });
                }

                if(excludeFiles) {
                    searchParams.append("exclude_files", excludeFiles);
                }

                return `/${slug}/generic-fields?` + searchParams.toString();
            },
            getPbFields: (slug, page = 1, perPage = 10, search = "", uids = [], invoiceable = false, genericFieldUids = []) => {
                let searchParams = new URLSearchParams({
                    page,
                    per_page: perPage,
                });

                if (search && search.length > 0) {
                    searchParams.append("name", search);
                }

                if(uids && uids.length > 0) {
                    uids.forEach((uid) => {
                        searchParams.append("uids[]", uid);
                    });
                }

                // todo: remove once filters are using pbfields
                if(genericFieldUids && genericFieldUids.length > 0) {
                    genericFieldUids.forEach((uid) => {
                        searchParams.append("generic_field_uids[]", uid);
                    });
                }

                if(invoiceable) {
                    searchParams.append("invoiceable", invoiceable);
                }

                return `/${slug}/pb-fields?` + searchParams.toString();
            },
            addField: (slug) => `/${slug}/profile-builder/attach-field`,
            reorder: (slug) => `/${slug}/pb-fields/reorder`,
            show: (slug, uid) => `/${slug}/pb-fields/${uid}`,
            update: (slug, uid) => `/${slug}/pb-fields/${uid}`,
            updateMagicGroups: (slug, uid) => `/${slug}/pb-fields/${uid}/magic-groups`,
            previewMagicGroupReactivation: (slug, uid) => `/${slug}/pb-fields/${uid}/magic-groups/preview`,
            bulkDelete: (slug) => `/${slug}/pb-fields/bulk-destroy`,
            bulkMove: (slug) => `/${slug}/pb-fields/bulk-move`,
            bulkUpdate: (slug) => `/${slug}/pb-fields/bulk-update`,
        },
        pinned: {
            index: (slug) => `/${slug}/pinned-pb-fields`,
            store: (slug) => `/${slug}/pinned-pb-fields`,
            delete: (slug, uid) => `/${slug}/pinned-pb-fields/${uid}`,
        },
    },
    groups: {
        create: (slug) => `/${slug}/groups`,
        get: (slug, page = 1, perPage = 10, search = "", excludeMagic = false, memberUids = []) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("name", search);
            }

            if (excludeMagic) {
                searchParams.append("exclude_magic", "1");
            }

            memberUids.forEach((uid) => {
                searchParams.append("member_uids[]", uid);
            });

            return `/${slug}/groups?` + searchParams.toString();
        },
        delete: (slug, uid) => `/${slug}/groups/${uid}`,
        deleteChatGroup: (slug, uid) => `/${slug}/groups/${uid}/chat-group`,
        associateMembers: (slug, uid) => `/${slug}/groups/${uid}/members`,
        disassociateMembers: (slug, uid) => `/${slug}/groups/${uid}/dissociate-members`,
        show: (slug, uid) => `/${slug}/groups/${uid}`,
        reactivationPreview: (slug, uid) => `/${slug}/groups/${uid}/reactivation-preview`,
        deactivate: (slug, uid) => `/${slug}/groups/${uid}/deactivate`,
        update: (slug, uid) => `/${slug}/groups/${uid}`,
        avatar: {
            store: (slug, groupUid) => `/${slug}/groups/${groupUid}/avatar`,
            delete: (slug, groupUid) => `/${slug}/groups/${groupUid}/avatar`,
        },
    },
    howToGuide: {
        index: (slug) => `/${slug}/how-to-guide`,
    },
    fieldAutomations: {
        create: (slug) => `/${slug}/automations`,
        update: (slug, id) => `/${slug}/automations/${id}`,
        get: (slug, page = 1, perPage = 10, search = '') => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("name", search);
            }

            return `/${slug}/automations?` + searchParams.toString();
        },
        delete: (slug, uid) => `/${slug}/automations/${uid}`,
    },
    beeFree: {
        getAccessToken: (slug) => `/${slug}/email_builder_access_token`,
    },
    chat: {
        getAccessToken: (slug) => `/${slug}/chat_access_token`,
    },
    sms: {
        create: (slug) => `/${slug}/sms`,
        get: (
            slug,
            page = 1,
            perPage = 10,
            search = "",
            date = "",
            filter = ""
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if (date.length > 0) {
                searchParams.append("date", date);
            }

            switch (filter) {
            case "scheduled":
                searchParams.append("scheduled", 1);
                break;
            case "sent":
                searchParams.append("sent", 1);
                break;
            case "draft":
                searchParams.append("draft", 1);
                break;
            default:
                break;
            }

            return `/${slug}/sms?` + searchParams.toString();
        },
        update: (slug, uid) => `/${slug}/sms/${uid}`,
        showSMS: (slug, uid) => `/${slug}/sms/${uid}`,
        delete: (slug, uid) => `/${slug}/sms/${uid}`,
        cancelScheduled: (slug, uid) => `/${slug}/sms/${uid}/cancel-scheduled`,
    },
    email: {
        create: (slug) => `/${slug}/emails`,
        get: (
            slug,
            page = 1,
            perPage = 10,
            search = "",
            date = "",
            filter = ""
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if (date.length > 0) {
                searchParams.append("date", date);
            }

            switch (filter) {
            case "scheduled":
                searchParams.append("scheduled", 1);
                break;
            case "sent":
                searchParams.append("sent", 1);
                break;
            case "draft":
                searchParams.append("draft", 1);
                break;
            case "bin":
                searchParams.append("bin", 1);
                break;
            default:
                break;
            }

            return `/${slug}/emails?` + searchParams.toString();
        },
        showEmail: (slug, uid) => `/${slug}/emails/${uid}`,
        update: (slug, uid) => `/${slug}/emails/${uid}`,
        delete: (slug, uid) => `/${slug}/emails/${uid}`,
        cancelScheduled: (slug, uid) => `/${slug}/emails/${uid}/cancel-scheduled`,
        attachments: (slug) => `/${slug}/emails/attachments`,
    },
    smsInbox: {
        get: (
            slug,
            page = 1,
            perPage = 10,
            search = "",
            date = "",
            filter = ""
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if (date.length > 0) {
                searchParams.append("date", date);
            }

            switch (filter) {
            case "favorite":
                searchParams.append("favorite", 1);
                break;
            case "bin":
                searchParams.append("bin", 1);
                break;
            default:
                break;
            }

            return `/${slug}/sms-inbox?` + searchParams.toString();
        },
        update: (slug, uid) => `/${slug}/sms-inbox/${uid}`,
        delete: (slug, uid) => `/${slug}/sms-inbox/${uid}`,
    },
    emailInbox: {
        get: (
            slug,
            page = 1,
            perPage = 10,
            search = "",
            date = "",
            filter = ""
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if (date.length > 0) {
                searchParams.append("date", date);
            }

            switch (filter) {
            case "favorite":
                searchParams.append("favorite", 1);
                break;
            case "bin":
                searchParams.append("bin", 1);
                break;
            default:
                break;
            }

            return `/${slug}/email-inbox?` + searchParams.toString();
        },
        update: (slug, uid) => `/${slug}/email-inbox/${uid}`,
        delete: (slug, uid) => `/${slug}/email-inbox/${uid}`,
    },
    publicAssets: {
        show: (slug, type) => `/${slug}/public-assets/${type}`,
    },
    files: {
        create: (slug) => `/${slug}/files`,
        download: (slug, fileName) => `/${slug}/files/download/${fileName}`,
        delete: (slug, fileName) => `/${slug}/files/${fileName}`,
        update: (slug, fileName) => `/${slug}/files/${fileName}`,
        get: (slug, uids = [])  => {
            let searchParams = new URLSearchParams();
            if(uids && uids.length > 0) {
                uids.forEach((uid) => {
                    searchParams.append("uids[]", uid);
                });
            }
            return `/${slug}/files?` + searchParams.toString();
        },
    },
    news: {
        create: (slug) => `/${slug}/articles`,
        get: (slug, uid) => `/${slug}/articles/${uid}`,
        update: (slug, uid) => `/${slug}/articles/${uid}`,
        delete: (slug, uid) => `/${slug}/articles/${uid}`,
        list: (
            slug,
            page = 1,
            perPage = 12,
            search = "",
            startDate = "",
            endDate = "",
            filters = "",
            tags = []
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if (startDate.length > 0) {
                searchParams.append("published_start", startDate);
            }

            if (endDate.length > 0) {
                searchParams.append("published_end", endDate);
            }

            switch (filters) {
            case "published":
                searchParams.append("published", 1);
                break;
            case "scheduled":
                searchParams.append("published", 0);
                break;
            case "draft":
                searchParams.append("draft", 1);
                break;
            case "bin":
                searchParams.append("bin", 1);
                break;
            case "liked":
                searchParams.append("liked", 1);
                break;
            case "all_news":
            default:
                searchParams.append("all_news", 1);
                break;
            }

            tags.forEach((tag) => {
                searchParams.append("tags[]", tag);
            });

            return `/${slug}/articles?` + searchParams.toString();
        },
        getPublicNews: (slug, page = 1, perPage = 10) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            return `/${slug}/public-news?` + searchParams.toString();
        },
        getPublicArticle: (slug, uid) => `/${slug}/public-news/${uid}`,
        like: (slug, uid) => `/${slug}/articles/${uid}/like`,
        unlike: (slug, uid) => `/${slug}/articles/${uid}/unlike`,
        share: (slug, uid) => `/${slug}/articles/${uid}/share`,
    },
    tags: {
        list: (slug, page = 1, perPage = 10, search = "") => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            return `/${slug}/tags?` + searchParams.toString();
        },
    },
    likes: {
        create: (slug, uid) => `/${slug}/articles/${uid}/like`,
        delete: (slug, uid) => `/${slug}/articles/${uid}/unlike`,
    },
    resources: {
        get: (slug, uid) => `/${slug}/resources/${uid}`,
        delete: (slug, uid) => `/${slug}/resources/${uid}`,
        list: (
            slug,
            page = 1,
            perPage = 12,
            search = "",
            startDate = "",
            endDate = "",
            type = "",
            tags = [],
            filter = "",
            orderBy = "",
            orderByDirection = "",
            category = "",
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if (startDate.length > 0) {
                searchParams.append("published_start", startDate);
            }

            if (endDate.length > 0) {
                searchParams.append("published_end", endDate);
            }

            if (type && type.length > 0) {
                searchParams.append("type", type);
            }

            tags.forEach((tag) => {
                searchParams.append("tags[]", tag);
            });

            if(orderBy && orderBy.length > 0) {
                searchParams.append("orderBy", orderBy);
            }

            if(orderByDirection && orderByDirection.length > 0) {
                searchParams.append("orderByDirection", orderByDirection);
            }

            if(category && category.length > 0) {
                searchParams.append("resource_category_uid", category);
            }

            if (filter && filter.length > 0) {
                switch (filter) {
                case 'bin':
                    searchParams.append("bin", 1);
                    break;
                case 'liked':
                    searchParams.append("liked", 1);
                    break;
                case 'draft':
                    searchParams.append('draft', 1);
                    break;
                case 'all_resources':
                default:
                    searchParams.append("all_resources", 1);
                }
            }

            return `/${slug}/resources?` + searchParams.toString();
        },
        like: (slug, uid) => `/${slug}/resources/${uid}/like`,
        unlike: (slug, uid) => `/${slug}/resources/${uid}/unlike`,
        show: (slug, uid) => `/${slug}/resources/${uid}`,
        share: (slug, uid) => `/${slug}/resources/${uid}/share`,
    },
    weblinks: {
        create: (slug) => `/${slug}/weblinks`,
        get: (slug, uid) => `/${slug}/weblinks/${uid}`,
        update: (slug, uid) => `/${slug}/weblinks/${uid}`,
    },
    pages: {
        create: (slug) => `/${slug}/pages`,
        get: (slug, uid) => `/${slug}/pages/${uid}`,
        update: (slug, uid) => `/${slug}/pages/${uid}`,
    },
    resourceCategories: {
        get: (slug) => `/${slug}/resource-categories`,
    },
    documents: {
        folder: {
            create: (organizationSlug) => `/${organizationSlug}/folders`,
            show: (organizationSlug, folderUid) => `/${organizationSlug}/folders/${folderUid}`,
            update: (organizationSlug, folderUid) => `/${organizationSlug}/folders/${folderUid}`,
        },
        document: {
            create: (organizationSlug) => `/${organizationSlug}/documents`,
            show: (organizationSlug, documentableUid) => `/${organizationSlug}/documentables?documentable_uid=${documentableUid}`,
            update: (organizationSlug, documentUid) => `/${organizationSlug}/documents/${documentUid}`,
        },
        list: (
            organizationSlug,
            page = 1,
            perPage = 12,
            search = "",
            orderBy = "title",
            folderUid = null,
            orderByDirection = 'asc',
        ) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if (orderBy.length > 0) {
                searchParams.append("orderBy", orderBy);
            }

            searchParams.append('orderByDirection', orderByDirection)

            if(folderUid) {
                searchParams.append('folder_uid', folderUid)
            }

            return `/${organizationSlug}/documentables?` + searchParams.toString();
        },
        like: (organizationSlug, documentUid) => `/${organizationSlug}/documentables/${documentUid}/like`,
        unlike: (organizationSlug, documentUid) => `/${organizationSlug}/documentables/${documentUid}/unlike`,
        delete: (organizationSlug) => `/${organizationSlug}/documentables/delete`,
        share: (organizationSlug, documentUid) => `/${organizationSlug}/documentables/${documentUid}/share`,
        move: (organizationSlug) => `/${organizationSlug}/documentables/move`,
    },
    rssFeed: (organizationSlug) => `/${organizationSlug}/rss-feed`,
    communicationEvents: {
        get: (slug, uid = '', page = 1, perPage = 10, event_type = [], search = '') => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search.length > 0) {
                searchParams.append("search", search);
            }

            if(event_type.length > 0) {
                event_type.forEach((type) => {
                    searchParams.append("event_type[]", type);
                });
            }

            if (uid) {
                searchParams.append("model_uid", uid);
            }

            return `/${slug}/communication-events?` + searchParams.toString();
        },
    },
    tinyMce: {
        request: (slug) => `/${slug}/tinymce/ai/request`,
    },
    AIGenerator: {
        generateImage: (slug) => `/${slug}/generate-image`,
    },
    SmartyAddress: {
        autocomplete: (slug) => `/${slug}/smarty/autocomplete`,
    },
    batches: {
        list: (slug) => `/${slug}/batches`,
        show: (slug, batchId) => `/${slug}/batches/${batchId}`,
    },
    benefitClaims: {
        list: (slug, memberUID, page = 1, perPage = 15, search = '', filters = {}) => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search && search.length > 0) {
                searchParams.append("search", search);
            }

            if (filters.status) {
                searchParams.append("status", filters.status);
            }

            if (filters.benefit_uid) {
                searchParams.append("benefit_uid", filters.benefit_uid);
            }

            if (filters.recipient_type) {
                searchParams.append("recipient_type", filters.recipient_type);
            }

            if (filters.date_from) {
                searchParams.append("date_from", filters.date_from);
            }

            if (filters.date_to) {
                searchParams.append("date_to", filters.date_to);
            }

            if (filters.orderBy) {
                searchParams.append("orderBy", filters.orderBy);
            }

            if (filters.orderByDirection) {
                searchParams.append("orderByDirection", filters.orderByDirection);
            }

            return `/${slug}/members/${memberUID}/benefit-claims?` + searchParams.toString();
        },
        summary: (slug, memberUID, filters = {}) => {
            let searchParams = new URLSearchParams();

            if (filters.date_from) {
                searchParams.append("date_from", filters.date_from);
            }

            if (filters.date_to) {
                searchParams.append("date_to", filters.date_to);
            }

            const queryString = searchParams.toString();
            return `/${slug}/members/${memberUID}/benefit-claims/summary${queryString ? '?' + queryString : ''}`;
        },
        create: (slug, memberUID) => `/${slug}/members/${memberUID}/benefit-claims`,
        update: (slug, memberUID, claimUID) => `/${slug}/members/${memberUID}/benefit-claims/${claimUID}`,
        delete: (slug, memberUID, claimUID) => `/${slug}/members/${memberUID}/benefit-claims/${claimUID}`,
        show: (slug, memberUID, claimUID) => `/${slug}/members/${memberUID}/benefit-claims/${claimUID}`,
        history: (slug, memberUID, claimUID) => `/${slug}/members/${memberUID}/benefit-claims/${claimUID}/history`,
        export: (slug, memberUID, filters = {}) => {
            let searchParams = new URLSearchParams();

            if (filters.status) {
                searchParams.append("status", filters.status);
            }

            if (filters.benefit_uid) {
                searchParams.append("benefit_uid", filters.benefit_uid);
            }

            if (filters.recipient_type) {
                searchParams.append("recipient_type", filters.recipient_type);
            }

            if (filters.date_from) {
                searchParams.append("date_from", filters.date_from);
            }

            if (filters.date_to) {
                searchParams.append("date_to", filters.date_to);
            }

            return `/${slug}/members/${memberUID}/benefit-claims/export?` + searchParams.toString();
        },
        dashboardList: (slug, page = 1, perPage = 15, search = '', filters = {}) => {
            let searchParams = new URLSearchParams({ page, per_page: perPage });

            if (search) searchParams.append("search", search);

            const filterKeys = ['status', 'benefit_uid', 'benefit_category_uid', 'recipient_type', 'date_from', 'date_to', 'orderBy', 'orderByDirection'];
            filterKeys.forEach(key => { if (filters[key]) searchParams.append(key, filters[key]); });

            return `/${slug}/benefit-claims?` + searchParams.toString();
        },
        bulkChangeStatus: (slug) => `/${slug}/benefit-claims/bulk/change-status`,
        dashboardExport: (slug) => `/${slug}/benefit-claims/export`,
        exportedCount: (slug) => `/${slug}/benefit-claims/exported-count`,
    },
    payments: {
        historyStatuses: (slug) => `/${slug}/finvo/history-statuses`,
        memberInvoiceStatuses: (slug) => `/${slug}/finvo/member-invoice-statuses`,
        list: (slug, page = 1, perPage = 15, status = '', createdDate = '', dueDate = '') => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (status && status.length > 0) {
                searchParams.append("status", status);
            }

            if (createdDate && createdDate.length > 0) {
                const formattedCreatedDate = Array.isArray(createdDate) ? createdDate.join(',') : createdDate;
                searchParams.append("created_date", formattedCreatedDate);
            }

            if (dueDate && dueDate.length > 0) {
                const formattedDueDate = Array.isArray(dueDate) ? dueDate.join(',') : dueDate;
                searchParams.append("due_date", formattedDueDate);
            }

            return `/${slug}/finvo?` + searchParams.toString();
        },
        show: (slug, batchUid) => `/${slug}/finvo/${batchUid}`,
        invoices: (slug, batchUid, page = 1, perPage = 15, search = '', status = '') => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search && search.length > 0) {
                searchParams.append("search", search);
            }

            if (status && status.length > 0) {
                searchParams.append("status", status);
            }

            return `/${slug}/finvo/${batchUid}/invoices?` + searchParams.toString();
        },
    },
    paymentDefinitions: {
        index: (slug) => `/${slug}/payment-definitions`,
        update: (slug) => `/${slug}/payment-definitions`,
        refresh: (slug) => `/${slug}/payment-definitions/refresh`,
    },
    paymentOptionGroups: {
        index: (slug) => `/${slug}/payment-option-groups`,
        store: (slug) => `/${slug}/payment-option-groups`,
        update: (slug, uid) => `/${slug}/payment-option-groups/${uid}`,
        destroy: (slug, uid) => `/${slug}/payment-option-groups/${uid}`,
    },
    benefitDefinitions: {
        getConfig: (slug) => `/${slug}/beneficiaries-config`,
        updateConfig: (slug) => `/${slug}/beneficiaries-config`,
        add: (slug) => `/${slug}/benefits`,
        update: (slug, benefitUid) => `/${slug}/benefits/${benefitUid}`,
        delete: (slug, benefitUid) => `/${slug}/benefits/${benefitUid}`,
        get: (slug, benefitUid) => `/${slug}/benefits/${benefitUid}`,
        list: (slug, page = 1, perPage = 10, search = '') => {
            let searchParams = new URLSearchParams({
                page,
                per_page: perPage,
            });

            if (search && search.length > 0) {
                searchParams.append("name", search);
            }

            return `/${slug}/benefits?` + searchParams.toString();
        },
        getSelectOptions: (slug) => `/${slug}/benefits/options`,
    },
    benefitCategories: {
        list: (slug, page = 1, perPage = 10, search = '') => {
            let searchParams = new URLSearchParams({ page, per_page: perPage });
            if (search && search.length > 0) searchParams.append('name', search);
            return `/${slug}/benefit-categories?` + searchParams.toString();
        },
        add: (slug) => `/${slug}/benefit-categories`,
        restore: (slug, uid) => `/${slug}/benefit-categories/${uid}/restore`,
    },
    policies: {
        list: (slug) => `/${slug}/policies`,
        create: (slug) => `/${slug}/policies`,
        update: (slug, uid) => `/${slug}/policies/${uid}`,
        delete: (slug, uid) => `/${slug}/policies/${uid}`,
    },
    policyTypes: {
        list: (slug) => `/${slug}/policy-types`,
    },
    impersonation: {
        start: (userUid) => `/api/impersonation/${userUid}`,
        stop: '/api/impersonation',
    },
    calendar: {
        events: {
            list: (slug, rangeStart, rangeEnd, types = []) => {
                const searchParams = new URLSearchParams({
                    range_start: rangeStart,
                    range_end: rangeEnd,
                });

                types.forEach((typeUid) => {
                    searchParams.append('types[]', typeUid);
                });

                return `/${slug}/calendar/events?` + searchParams.toString();
            },
            create: (slug) => `/${slug}/calendar/events`,
            show: (slug, uid) => `/${slug}/calendar/events/${uid}`,
            update: (slug, uid) => `/${slug}/calendar/events/${uid}`,
            delete: (slug, uid) => `/${slug}/calendar/events/${uid}`,
            rsvp: (slug, uid) => `/${slug}/calendar/events/${uid}/rsvp`,
            attendees: (slug, uid, status, page = 1, perPage = 20) => {
                const searchParams = new URLSearchParams({
                    status,
                    page,
                    per_page: perPage,
                });
                return `/${slug}/calendar/events/${uid}/attendees?` + searchParams.toString();
            },
        },
        eventTypes: {
            list: (slug) => `/${slug}/calendar/event-types`,
        },
    },
};
